//#region  PATH AUTH

export const PATH_DASHBOARD = {
	dashboard: {
		justPath: ''
	}
};

const loginPage = 'login';
const changePassword = 'change-password';
const firstLogin = 'first-login';

export const PATHS_AUTH_PAGES = {
	loginPage: {
		withSlash: `/${loginPage}`,
		justPath: loginPage
	},
	changePassword: {
		withSlash: `/${changePassword}`,
		justPath: changePassword
	},
	firstLogin: {
		withSlash: `/${firstLogin}`,
		justPath: firstLogin
	}
};
//#endregion

//#region PATH QUERYS
const querys = 'querys';
const querysSavingAndCts = 'saving-and-cts';
const querysFixedDeposit = 'fixed-deposit';
const querysLoans = 'loans';
const querysContributions = 'contributions';

export const PATHS_QUERYS_PAGES = {
	querys: querys,
	savingCts: {
		withSlash: `/${querys}/${querysSavingAndCts}`,
		justPath: querysSavingAndCts
	},
	fixedDeposit: {
		withSlash: `/${querys}/${querysFixedDeposit}`,
		justPath: querysFixedDeposit
	},
	loans: {
		withSlash: `/${querys}/${querysLoans}`,
		justPath: querysLoans
	},
	contributions: {
		withSlash: `/${querys}/${querysContributions}`,
		justPath: querysContributions
	}
};

//#endregion

//#region PATH TRANSFERS
const transfers = 'transfers';
const transfersbetweenAccount = 'between-account';
const transfersOtherAccount = 'other-account';
const transfersToBank = 'transfers-to-bank';
const transfersFromBankToPacifico = 'from-banks-to-pacifico';

export const PATHS_TRANSFERS_PAGES = {
	transfers: transfers,
	betweenAccount: {
		withSlash: `/${transfers}/${transfersbetweenAccount}`,
		justPath: transfersbetweenAccount
	},
	otherAccount: {
		withSlash: `/${transfers}/${transfersOtherAccount}`,
		justPath: transfersOtherAccount
	},
	transfersToBank: {
		withSlash: `/${transfers}/${transfersToBank}`,
		justPath: transfersToBank
	},
	transfersFromBankToPacifico: {
		withSlash: `/${transfers}/${transfersFromBankToPacifico}`,
		justPath: transfersFromBankToPacifico
	}
};
//#endregion

//#region PATH PAYMENTS
const payments = 'payments';
const paymentsServicesPay = 'services-pay';
const loanFeePayment = 'loan-fee-payment';
const paymentsCancellationPayment = 'loan-cancellation-payment';
const paymentsSheduledSavingPayment = 'sheduled-saving-payment';
const paymentsOfContributions = 'payments-of-contributions';

export const PATHS_PAYMENTS_PAGES = {
	payments: payments,
	servicesPay: {
		withSlash: `/${payments}/${paymentsServicesPay}`,
		justPath: paymentsServicesPay
	},
	loanFeePayment: {
		withSlash: `/${payments}/${loanFeePayment}`,
		justPath: loanFeePayment
	},
	cancellationPayment: {
		withSlash: `/${payments}/${paymentsCancellationPayment}`,
		justPath: paymentsCancellationPayment
	},
	sheduledSavingPayment: {
		withSlash: `/${payments}/${paymentsSheduledSavingPayment}`,
		justPath: paymentsSheduledSavingPayment
	},
	paymentsOfContributions: {
		withSlash: `/${payments}/${paymentsOfContributions}`,
		justPath: paymentsOfContributions
	}
};
//#endregion

//#region PATH SAVING
const savingsIsInvestments = 'savings-invesments';
const savingsIsInvestmentsFixedTerm = 'investments';
const savingsIsInvestmentsGiftFixedTerm = 'investments-gift';
const savingsIsInvestmentsScheduleSaving = 'schedule-saving';
const savingsIsInvestmentsSavings = 'savings';
const savingsIsInvestmentsCTS = 'cts';

export const PATHS_SAVINGS_INVESMENTS_PAGES = {
	savingsIsInvestments: savingsIsInvestments,
	fixedTerm: {
		withSlash: `/${savingsIsInvestments}/${savingsIsInvestmentsFixedTerm}`,
		justPath: savingsIsInvestmentsFixedTerm
	},
	giftfixedTerm: {
		withSlash: `/${savingsIsInvestments}/${savingsIsInvestmentsGiftFixedTerm}`,
		justPath: savingsIsInvestmentsGiftFixedTerm
	},
	scheduleSaving: {
		withSlash: `/${savingsIsInvestments}/${savingsIsInvestmentsScheduleSaving}`,
		justPath: savingsIsInvestmentsScheduleSaving
	},
	savings: {
		withSlash: `/${savingsIsInvestments}/${savingsIsInvestmentsSavings}`,
		justPath: savingsIsInvestmentsSavings
	},
	cts: {
		withSlash: `/${savingsIsInvestments}/${savingsIsInvestmentsCTS}`,
		justPath: savingsIsInvestmentsCTS
	}
};
//#endregion

//#region PATH CARD DEVIT
const devit = 'devit';
const devitConfigureYourCards = 'configure-your-cards';
const devitDiscountWithCard = 'discount-with-Card';

export const PATHS_DEVIT = {
	devit: devit,
	configureYourCards: {
		withSlash: `/${devit}/${devitConfigureYourCards}`,
		justPath: devitConfigureYourCards
	},
	discountWithCard: {
		withSlash: `/${devit}/${devitDiscountWithCard}`,
		justPath: devitDiscountWithCard
	}
};
//#endregion

//#region PATH MYINFORMATION
const myinformation = 'myinformation';
const myinformationlimits = 'limits';
const myinformationUpdatePhone = 'update-phone';
const myinformationUpdateEmail = 'update-email';
const myinformationUpdatePreference = 'update-preference';

export const PATHS_MYINFORMATION = {
	myinformation: myinformation,
	limits: {
		withSlash: `/${myinformation}/${myinformationlimits}`,
		justPath: myinformationlimits
	},
	updatePhone: {
		withSlash: `/${myinformation}/${myinformationUpdatePhone}`,
		justPath: myinformationUpdatePhone
	},
	updateEmail: {
		withSlash: `/${myinformation}/${myinformationUpdateEmail}`,
		justPath: myinformationUpdateEmail
	},
	updatePreference: {
		withSlash: `/${myinformation}/${myinformationUpdatePreference}`,
		justPath: myinformationUpdatePreference
	}
};

//#endregion

//#region PATH FREQUENT OPERATIONS
const frequentOperations = 'frequent-operations';

export const PATHS_FREQUENT_OPERATION = {
	frequentOperations: frequentOperations
};
//#endregion

//#region PATH PROFILE SETTING
const setting = 'setting';
const settingMessage = 'message';
const settingAlert = 'alert';
const settingChangeImage = 'change-image';
const settingChangePassword = 'change-password';
const settingProfileData = 'profile-data';

export const PATHS_SETTING = {
	setting: setting,
	settingMessage: {
		withSlash: `/${setting}/${settingMessage}`,
		justPath: settingMessage
	},
	settingAlert: {
		withSlash: `/${setting}/${settingAlert}`,
		justPath: settingAlert
	},
	settingChangeImage: {
		withSlash: `/${setting}/${settingChangeImage}`,
		justPath: settingChangeImage
	},
	settingChangePassword: {
		withSlash: `/${setting}/${settingChangePassword}`,
		justPath: settingChangePassword
	},
	settingProfileData: {
		withSlash: `/${setting}/${settingProfileData}`,
		justPath: settingProfileData
	}
};
//#endregion

//#region PATH LOANS OPERATIONS
const loansOperations = 'loans-operations';
const loansOnline = 'loans-online';

export const PATHS_LOANS_OPERATIONS = {
	loansOperations: loansOperations,
	loansOnline: {
		withSlash: `/${loansOperations}/${loansOnline}`,
		justPath: loansOnline
	}
};
//#endregion

//#region PATH EXCHANGE RATES
const exchangeOperations = 'exchange-operations';
const exchangeRate = 'exchange-rate';

export const PATHS_EXCHANGE_RATES = {
	exchangeOperations: exchangeOperations,
	exchangeRate: {
		withSlash: `/${exchangeOperations}/${exchangeRate}`,
		justPath: exchangeRate
	}
};
//#endregion

//#region
export const PATH_IN_CONSTRUCTION = {
	inConstruction: { withSlash: '/in-construction', justPath: 'in-construction' }
};
//#endregion

//#region
export const PATH_ADVERTISING = {
	advertising: { withSlash: '/advertising', justPath: 'advertising' }
};
//#endregion
